import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';
import { User } from '../users';

export interface Quarry {
    _id: string;
    designation: string;
    crudStatus: number;
    createdBy?: {
        _id: string;
        firstName: string;
        lastName: string;
    };
    address?: string;
    usageCount?: {
        total: number;
        dailyTransfers: number;
        dailyTransferRides: number;
        dailyTrucksPlanned: number;
        dailyTrucksRides: number;
    };
    updatedAt?: string;
    createdAt?: string;
}
export interface QuarriesResponse {
    message: string;
    data: Quarry[];
}

export interface GetQuarriesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllQuarries = async (queries?: GetQuarriesQueries): Promise<QuarriesResponse> => {
    try {
        const response: AxiosResponse<QuarriesResponse> = await apiClient.get('/quarries', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateQuarryBody {
    designation?: string;
    crudStatus?: number;
    address?: string;
}

export interface QuarryResponse {
    message: string;
    data: Quarry;
}

export const updateQuarry = async (loadNatureId: string, data: UpdateQuarryBody): Promise<QuarryResponse> => {
    try {
        const response: AxiosResponse<QuarryResponse> = await apiClient.patch('/quarries/' + loadNatureId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateQuarryBody {
    designation: string;
    address?: string;
    crudStatus?: number;
    createdBy?: string;
}

export const createQuarry = async (data: CreateQuarryBody): Promise<QuarryResponse> => {
    try {
        const response: AxiosResponse<QuarryResponse> = await apiClient.post('/quarries', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface ReplaceQuarryIdBody {
    oldId: string;
    newId: string;
}

export interface ReplaceQuarryIdResponse {
    message: string;
    details: string;
}

export const replaceQuarryId = async (data: ReplaceQuarryIdBody): Promise<ReplaceQuarryIdResponse> => {
    try {
        const response: AxiosResponse<ReplaceQuarryIdResponse> = await apiClient.patch('/quarries/replace-id', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
